
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import TreeNode from './TreeNode.vue';
import { treeNodeKey, TreeNodeObject } from '~/interfaces/helper.interface';
import { filterOnSearchText } from '~/helpers';
import TreeMixin from '~/mixins/tree.mixin';

@Component({
    components: {
        NetatmoIcon,
        TreeNode,
    },
})
export default class Tree extends Mixins(TreeMixin) {
    @Prop() readonly nodes!: TreeNodeObject[];
    @Prop() readonly search!: string;
    @Prop() readonly openSync!: string[];
    @Prop() readonly isInAHome!: boolean;
    @Prop() isOpen!: boolean;

    get openSyncComputed() {
        return this.openSync;
    }

    set openSyncComputed(openedNodes: string[]) {
        this.updateOpenedTreeNodes(openedNodes);
    }

    get filter() {
        return (item: TreeNodeObject, search: string) =>
            filterOnSearchText(item, search, [
                'primaryInfo',
                'secondaryInfo',
                'tertiaryInfo',
                'subType',
            ] as treeNodeKey[]);
    }

    @Watch('isOpen')
    handler(isOpen: boolean) {
        if (typeof this.$refs.tree !== 'undefined') {
            (this.$refs.tree as any).updateAll(isOpen);
        }
    }

    updateOpenedTreeNodes(openedNodes: string[]) {
        this.$emit('update-opened-nodes', openedNodes);
    }

    iconType(item: TreeNodeObject) {
        return item.subType ? item.subType : item.type;
    }
}
